module.exports = __webpack_public_path__ + "static/media/footer-icon-4.8da74659.svg";